
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";

interface AnalysisTipProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
}

const AnalysisTip = ({ 
  title, 
  description, 
  icon = <AlertCircle className="h-4 w-4 text-fraudeye-accent" />
}: AnalysisTipProps) => {
  return (
    <Alert variant="default" className="border-fraudeye-accent/50 bg-fraudeye-accent/10">
      {icon}
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>
        {description}
      </AlertDescription>
    </Alert>
  );
};

export default AnalysisTip;
